export function formatPhone(phone) {
  const formattedPhone = phone.replaceAll('-', '')
  return formattedPhone
}

export function formatZip(zip) {
  const formattedZip = zip.replaceAll('-', '')
  return formattedZip
}
